import React, {useCallback, useEffect, useState} from "react";
import {useHistory, useLocation, useParams, useRouteMatch} from "react-router-dom";
import {useDropzone} from 'react-dropzone'
import UTILS from "../../utils";
import {ErrorMessage, Field, Formik} from "formik";
import {
AiOutlineClockCircle,
AiOutlineClose,
AiOutlineCloudUpload,
AiOutlineFile,
AiOutlineUnorderedList
} from "react-icons/ai";
import Fields from "../formFields";
import {FaChevronDown} from "react-icons/fa";
import {assignmentMarks, assignTo} from "../../utils/assignment";
import {FiEdit2} from "react-icons/fi";
import {IoIosMenu} from "react-icons/io";
import {BsCheck2Circle, BsClipboard, BsHeadphones} from "react-icons/bs";
import BlockCustomDialog from "./BlockCustomDialog";
import {useMutation} from "react-query";
import {PDF_FILE_SIZE} from '../../utils/config';
import {RiErrorWarningLine} from "react-icons/ri";
import {createAssignment, updateAssignment} from "../../api/assignment";
import {getClassDetailsById} from "../../utils/reactQueries";

const defaultValues = {
// file: '',
dueDays: 0,
assignTo: '',
markOf: '',
preview: false
}

export default function BlockUploadAssignment() {
const history = useHistory();
const {url} = useRouteMatch();
const param = useParams();
const classId = param.classId;
const location = useLocation();
const [initialValues, _initialValues] = useState(defaultValues);
const [isOpen, setOpen] = useState(false);
// const [classDetails, _classDetails] = useState({});
const [fileRejected, _fileRejected] = useState(false);
const [isFileLarge, _isFileLarge] = useState(false);
const [preview, setPreview] = useState(false);
const [selectedFile, setSelectedFile] = useState([]);
const [editAssignment, _editAssignment] = useState({});
const fileUpload = useCallback((acceptedFiles, rejectedFiles, isDragReject) => {
//check the file is large then 10MB
const isFileTooLarge = rejectedFiles?.length > 0 && rejectedFiles[0]?.file?.size > PDF_FILE_SIZE;
if (rejectedFiles?.length > 0) {
_fileRejected(true);
_isFileLarge(isFileTooLarge);
} else {
setSelectedFile([...selectedFile, ...acceptedFiles]);
const fileData = acceptedFiles[0];
const formValues = {
...initialValues,
file: fileData.name,
}
_initialValues(formValues);
}

}, [selectedFile]);

//drag the files using this function
const {
isDragActive,
getRootProps,
getInputProps,
isDragReject,
acceptedFiles,
rejectedFiles,
inputRef
} = useDropzone({
onDrop: fileUpload,
accept: {
'application/pdf': ['.pdf']
},
maxSize: PDF_FILE_SIZE,
multiple: false,
});


const goToAssignmentList = () => {
history.push(`${url}/assignment-lists`);
}

useEffect(() => {
const assignmentData = location?.state?.assignmentData;
const splitURL = location.pathname.split('/');
const editPathURL = splitURL[splitURL.length - 1]
if (editPathURL === 'edit-assignment' && assignmentData) {
const data = {
...initialValues,
dueDays: assignmentData?.valid_for_days,
file: assignmentData?.title,
}
let metadata = {
type: 'application/pdf'
};
let file = new File([assignmentData?.assignmentUrl], `${assignmentData?.title}`, metadata);
setSelectedFile([file]);
_editAssignment(assignmentData);
_initialValues(data);
} else {
history.push(url);
}
}, []);


const {status, data, error, isFetching} = getClassDetailsById(classId);

const classDetails = data?.data;


//Upload assignment data
const {
mutate: uploadData,
} = useMutation(createAssignment, {
onSuccess: (data, variables) => {
setOpen(false);
_initialValues(defaultValues);
setPreview(false)
alert("File Uploaded SuccessFully");
history.push(`${url}/assignment-lists`);
},
onError: (err) => {
console.log(err);
alert("Something Went wrong...");
},
});

//Upload assignment data
const {
mutate: editAssignmentData,
} = useMutation(updateAssignment, {
onSuccess: (data, variables) => {
setOpen(false);
_initialValues(defaultValues);
setPreview(false)
alert("File Uploaded SuccessFully");
history.push(`${url}/assignment-lists`);
},
onError: (err) => {
console.log(err);
alert("Something Went wrong...");
},
});

const fncUploadAssignment = (values) => {
const formData = new FormData();
const assignmentData = {
title: values?.file,
description: '',
valid_for_days: values?.dueDays
}

formData.append("assignment", JSON.stringify(assignmentData));
formData.append('file', selectedFile[0]);
if (editAssignment?.id) {
editAssignmentData({assignmentId: editAssignment?.id, assignmentData: formData})
} else {
uploadData(formData);
}

}

const handleSubmit = (values, {setSubmitting}) => {

if (selectedFile?.length === 0) {
alert("Select the Assignment PDF");
} else {
const newData = {
...values,
preview: true
}
setPreview(true);
_initialValues(newData)
}
}

const removeAll = () => {
setSelectedFile([])
const formValues = {
...initialValues,
file: '',
}
_initialValues(formValues);
}


return (
<>
<div className="flex flex-col flex-auto justify-between">
<Formik
initialValues={initialValues}
enableReinitialize
validationSchema={UTILS.forms.AddingAssignmentSchema}
onSubmit={handleSubmit}
>
{({values, handleSubmit, isSubmitting, errors, setValues, setFieldValue}) => (
<form onSubmit={handleSubmit}
className="flex flex-col"
style={{minHeight: '50vh'}}>
{!preview ? <>
<div>

<div
className={`uploadAssignment dashBorder ${(fileRejected || values?.file) ? `${fileRejected && 'errorBorder'} uploadSectionResponseHeight` : 'uploadSectionHeight'}`}>

{fileRejected ? <div>
<div>
<div className="flex justify-between items-center">
<span className="text-xl text-black">
{isFileLarge ? 'Maximum 10 mbs can be uploaded' : 'Please Select the PDF File'}
</span>
<AiOutlineClose
className="text-black text-2xl cursor-pointer"
onClick={() => {
_fileRejected(false);
_isFileLarge(false);
removeAll();
}}
/>
</div>
<div className="flex justify-start items-center gap-3 mt-5">
<RiErrorWarningLine className="text-red-400 text-2xl
"/>
<span
className="text-sm text-black">Error</span>
</div>
</div>
</div> :
values?.file ?
<div>
<div className="flex justify-between items-center">
<span className="text-xl text-black">{values?.file}</span>
<AiOutlineClose
className="text-black text-2xl cursor-pointer"
onClick={() => {
setFieldValue('file', '');
removeAll();
}}
/>
</div>
<div className="flex justify-start items-center gap-3 mt-5">
<BsCheck2Circle className="text-green-600 text-2xl
"/>
<span
className="text-sm text-black">Uploaded successfully</span>
</div>
</div> :
<div {...getRootProps()}
className="flex justify-center items-center flex-col h-full">
<input {...getInputProps()} />
<AiOutlineCloudUpload className="uploadIcon"/>
<span className="text-xl text-black">Upload assignment</span>
<div className="flex justify-center items-center gap-3 mt-2">
<span>Drag and drop here</span>
<span>or</span>
<button
className="w-20 h-8 text-black font-[Poppins-Bold] browseBtn">
browse
</button>
</div>
</div>
}
</div>
<ErrorMessage
name={`file`}>
{(msg) => (
<div
className={"text-red-500 text-xs mt-5"}>
{msg}
</div>
)}
</ErrorMessage>
<div
className="flex flex-auto flex-col selectDays">
<Field
type="text"
name={`dueDays`}
component={Fields.FieldTimeCoverInput}
placeholder="Due After"
inputClasses=" days-to-cover text-lg rounded-tl-md rounded-bl-md w-9 "
wrapperClasses=" w-full"
unit="Days"
beforePlaceholder="Due after"
min={0}
iconUp={<FaChevronDown
className="text-lg rotate-180 cursor-pointer"/>}
iconDown={<FaChevronDown
className="text-lg cursor-pointer"/>}
timeIncrement={() => {
const currentValue = Number(values.dueDays) || 0; // Force conversion to number
setFieldValue(`dueDays`, currentValue + 1);
}}
timeDecrement={() => {
const currentValue = Number(values.dueDays) || 0; // Force conversion to number
setFieldValue(`dueDays`, Math.max(0, currentValue - 1)); // Ensures minimum 0
}}
/>
</div>

<div className="mt-7">
<h3 className="text-lg font-semibold mb-2 select-none">Assign to</h3>
<Field
type="select"
name={"assignTo"}
placeholder="Assign to all"
options={assignTo()}
component={Fields.FieldSelect}
/>
</div>
<div className="mt-4">
<h3 className="text-lg font-semibold mb-2 select-none">Marks out of</h3>
<Field
type="select"
name={"markOf"}
placeholder="Marks out of"
options={assignmentMarks()}
component={Fields.FieldSelect}
/>
</div>
</div>
</>
:
<div>
<div className="flex justify-between items-center">
<span className="text-black text-fs32">Assignment Summary</span>
<FiEdit2 className="text-xl cursor-pointer"
onClick={() => setPreview(false)}/>
</div>
<div className="mt-8 flex flex-col gap-10">
<div className="flex justify-between items-center">
<div className="flex justify-start items-center gap-3">
<span><IoIosMenu className="text-2xl"/></span>
<span className="text-xl">Subject : </span>
</div>
<div>
<span className="text-xl">{classDetails?.subject?.title}</span>
</div>
</div>
<div className="flex justify-between items-center">
<div className="flex justify-start items-center gap-3">
<span><BsHeadphones className="text-2xl"/></span>
<span className="text-xl">Class : </span>
</div>
<div>
<span className="text-xl">{classDetails?.title}</span>
</div>
</div>
<div className="flex justify-between items-center">
<div className="flex justify-start items-center gap-3">
<span><AiOutlineUnorderedList className="text-2xl"/></span>
<span className="text-xl">Topic : </span>
</div>
<div>
<span className="text-xl">{classDetails?.subject?.description}</span>
</div>
</div>
<div className="flex justify-between items-center">
<div className="flex justify-start items-center gap-3">
<span><AiOutlineFile className="text-2xl"/></span>
<span className="text-xl">Assignment : </span>
</div>
<div>
<span className="text-xl">{initialValues?.file}</span>
</div>
</div>
<div className="flex justify-between items-center">
<div className="flex justify-start items-center gap-3">
<span><AiOutlineClockCircle className="text-2xl"/></span>
<span className="text-xl">End Date : </span>
</div>
<div>
<span className="text-xl">{initialValues?.dueDays}</span>
</div>
</div>
<div className="flex justify-between items-center">
<div className="flex justify-start items-center gap-3">
<span><BsClipboard className="text-2xl"/></span>
<span className="text-xl">Marks : </span>
</div>
<div>
<span className="text-xl">{initialValues?.markOf?.label}</span>
</div>
</div>
</div>
</div>}
<div className="formFooter">
<div>
<span onClick={() => goToAssignmentList()}>View Assignments</span>
<button
  type="button"
  className="w-20 h-8 text-black browseBtn"
  onClick={() => {
    // Check for ANY changes (including dueDays alone)
    const hasChanges = (
      selectedFile.length > 0 ||
      values.dueDays !== defaultValues.dueDays || // Proper field name check
      values.assignTo !== defaultValues.assignTo ||
      values.markOf !== defaultValues.markOf
    );

    if (preview) {
      setPreview(false);
    } else if (hasChanges) {
      if (window.confirm('Discard changes?')) {
        removeAll();
        _initialValues(defaultValues); // Will properly reset dueDays to 0
        history.goBack();
      }
    } else {
      history.goBack();
    }
  }}
>
  Cancel
</button>
{preview ?
<button
type="button"
className="w-20 h-8 text-black font-[Poppins-Bold] browseBtn"
onClick={() => {
setOpen(true)
}}
>
Upload
</button> :
<button
type="submit"
className="w-20 h-8 text-black font-[Poppins-Bold] browseBtn"
>
next
</button>
}

</div>
</div>
<BlockCustomDialog
targetId="contentWrapperBox"
open={isOpen}
onClose={() => setOpen(false)}
overlayClasses="justify-center items-center backdrop-blur-md"
>
<div className="w-96 flex flex-col rounded-full p-4">
<h4 className="text-lg font-bold text-center">
Upload
</h4>
<div className="mt-3 mb-6">
<p className="text-center px-4">Are you sure you want to publish this
assignment to all the students?</p>
</div>
<div className="flex gap-x4">
<button
type="button"
onClick={() => fncUploadAssignment(values)}
className="w-40 mx-auto px-10 py-2 text-black border-2 border-black font-extrabold font-[Poppins-Bold] rounded-lg">
Yes
</button>
<button
onClick={() => setOpen(false)}
className="w-40 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
No
</button>
</div>
</div>
</BlockCustomDialog>
</form>
)}
</Formik>
</div>
</>
);
}